module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNBNkIwQkQiIGZpbGwtcnVsZT0ibm9uemVybyIKICAgICAgICAgIGQ9Ik0wIDYuOTk4Yy4wMi0uMTUuMDg0LS4zOTcuMTgtLjUxNEw1LjEyMi4zMDdBLjgyOS44MjkgMCAwIDEgNi4yOC4xNzhjLjMzNy4yNy4zOTguODIyLjEyOCAxLjE1OEwyLjUzNSA2LjE3NWgxMy45MzZhLjgyNC44MjQgMCAxIDEgMCAxLjY0N0gyLjUzNWwzLjg3MyA0LjgzOGMuMjcuMzM3LjE5NC44NzItLjEyOCAxLjE1OC0uMzM3LjMtLjg4OS4yMDktMS4xNTgtLjEyOEwuMTggNy41MTNjLS4xNC0uMTctLjE2OS0uMjk3LS4xOC0uNTE1eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/controls/back.svg
// module id = ./src/assets/controls/back.svg
// module chunks = 0